<template lang="pug">
.itemProgressVpr
  .badges
    .badge.success
      .icon
        ui-svg-icon( name="smile-success" )
      .text {{ childItem.counters.green || 0 }}
    .badge.part
      .icon
        ui-svg-icon( name="smile-normal" )
      .text {{ childItem.counters.yellow || 0 }}
    .badge.failed
      .icon
        ui-svg-icon( name="smile-failed" )
      .text {{ childItem.counters.red || 0 }}
</template>

<script>
import ChildVpr from '@/models/ChildVpr'
export default {
  props: {
    childItem: {
      type: ChildVpr,
      required: true
    }
  }
}
</script>

<style lang="sass" scoped>
.itemProgressVpr
  width: 100%
  > .badges
    width: 100%
    display: flex
    gap: $u
    align-items: center
    justify-content: space-between
    padding: 2*$u 4*$u
    border-radius: $brL
    background-color: $cElements

    >.badge
      width: 21*$u
      display: flex
      align-items: center
      background-color: $cWhite
      border-radius: 99em
      border-bottom: 1*$u solid $cDarkBackground
      padding: $u 1.5*$u
      @media (max-width: $mobileWidth)
        width: 18*$u

      .icon
        width: 7*$u
        color: $cWhite
        @media (max-width: $mobileWidth)
          width: 6*$u

      > .text
        @include font('t16-demibold')
        flex: 1
        text-align: center
</style>
